import { render, staticRenderFns } from "./parts.vue?vue&type=template&id=60d6370b&"
import script from "./js/parts.js?vue&type=script&lang=js&"
export * from "./js/parts.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports